(function () {
  'use strict';

  var QA_PREFIX = 'Subscriber QA:';
  var CUSTOMER_NOTICE = 'Changes are saved when you tap Update My Meals. You can update your weekly meals and extras until the cutoff shown above.';

  function cleanNotice() {
    var notice = document.getElementById('sw-cycle-notice');
    if (!notice) return;
    var text = String(notice.textContent || '').trim();
    if (text.indexOf(QA_PREFIX) === 0) notice.textContent = CUSTOMER_NOTICE;
  }

  function install() {
    cleanNotice();
    var notice = document.getElementById('sw-cycle-notice');
    if (!notice || typeof MutationObserver !== 'function') return;
    new MutationObserver(cleanNotice).observe(notice, { childList: true, characterData: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', install, { once: true });
  else install();
})();
